<template>
  <div class="room">
    <Header title="教室查询" type='0' route='/homeIndex'></Header>
    <van-form @submit="onSubmit">
      <van-field
        v-model="szxqName"
        is-link
        readonly
        clickable
        label="所在校区"
        input-align="right"
        error-message-align="right"
        placeholder="请选择"
        @click="szxqShow = true"
      />
      <van-field
        v-model="szlyName"
        is-link
        readonly
        clickable
        label="所在楼宇"
        input-align="right"
        error-message-align="right"
        placeholder="请选择"
        @click="szlyFcut"
      />
      <van-field
        v-model="jslxName"
        is-link
        readonly
        clickable
        label="教室类型"
        input-align="right"
        error-message-align="right"
        placeholder="请选择"
        @click="jslxShow = true"
      />
      <van-field
        v-model="sysjName"
        is-link
        readonly
        clickable
        label="使用时间"
        input-align="right"
        error-message-align="right"
        placeholder="请选择"
        @click="sysjShow = true"
      />
      <div class="button-box">
        <van-button class="box-tj" round type="info" color="#7469F8" native-type="submit">查询</van-button>
      </div>
    </van-form>
    <van-popup v-model="szxqShow" position="bottom">
      <van-picker show-toolbar :columns="szxqColumns" @confirm="szxqConfirm" @cancel="szxqShow = false"/>
    </van-popup>
    <van-popup v-model="szlyShow" position="bottom">
      <van-picker show-toolbar :columns="szlyColumns" @confirm="szlyConfirm" @cancel="szxqShow = false"/>
    </van-popup>
    <van-popup v-model="jslxShow" position="bottom">
      <van-picker show-toolbar :columns="jslxColumns" @confirm="jslxConfirm" @cancel="szxqShow = false"/>
    </van-popup>
    <van-popup v-model="sysjShow" position="bottom">
      <div class="sysj-text">
        <van-icon name="cross" size="22px" @click="sysjClose"/>
        <van-icon name="success" size="22px" @click="sysjConfirm"/>
      </div>
      <div class="all-cont">
        <div>
          <p style="color:#757DA3">周次</p>
          <div class="van-check">
            <div
            :class="['van-li',item.isCheck?'van-on':'']"
            v-for="(item,index) in zcColumns"
            :key="index"
            @click="zcxzFuct(item,index)">{{ item.text }}</div>
          </div>
        </div>
        <div>
          <p style="color:#757DA3">星期</p>
          <div class="van-check">
          <div
            :class="['van-li',item.isCheck?'van-on':'']"
            v-for="(item,index) in weekColumns"
            :key="index"
            @click="xqxzFuct(item,index)">{{ item.text }}</div>
          </div>
        </div>
        <div>
          <p style="color:#757DA3">节次</p>
          <div class="van-check">
            <div
            :class="['van-text',item.isCheck?'van-on':'']"
            v-for="(item,index) in jcColumns"
            :key="index"
            @click="jcxzFuct(item,index)">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Api } from "../../../../utils/axios";
export default{
  data(){
    return{
      szxqId:'',
      szxqName:'',
      szxqShow:false,
      szxqColumns:[],
      szlyId:'',
      szlyName:'',
      szlyColumns:[],
      szlyShow:false,
      jslxId:'',
      jslxName:'',
      jslxColumns:[],
      jslxShow:false,
      sysjName:'',
      zcId:'',
      xqId:'',
      jcid:'',
      zcColumns:[],
      weekColumns:[
        { text:"一", value:'1', isCheck:false },
        { text:"二", value:'2', isCheck:false },
        { text:"三", value:'3', isCheck:false },
        { text:"四", value:'4', isCheck:false },
        { text:"五", value:'5', isCheck:false },
        { text:"六", value:'6', isCheck:false },
        { text:"日", value:'7', isCheck:false },
      ],
      jcColumns:[],
      sysjShow:false,
      more:[],
      jcXzArr:[]
    }
  },
  created(){
    this.getCampus()
    this.getType()
    this.getTeaWeek()
    this.bigJcFuct()
  },
  methods:{
    szlyFcut(){
      if(this.szxqName===''){
        this.$toast('请选择校区')
        return
      }
      this.szlyShow = true
    },
    async getCampus() {
      const res = await Api.getCampusList();
      let concatList = [];
      concatList.push({
          text: "全部",
          value: ''
        })
      res.data.map((v) => {
        concatList.push({
          text: v.campusName,
          value: v.campusId
        })
      })
      this.szxqColumns = concatList
    },
    async getBuild(e) {
      const res = await Api.getTchBuildingList({
        xqid: e || ""
      });
      let concatList = [];
      concatList.push({
          text: "全部",
          value: ''
        })
      res.data.map((v) => {
        concatList.push({
          text: v.buildingName,
          value: v.buildingId
        })
      })
      this.szlyColumns = concatList
    },
    async getType() {
      const params = {
        table: "zzdjslx"
      };
      const res = await Api.getRoomType(params);
      let concatList = [];
      concatList.push({
          text: "全部",
          value: ''
        })
      res.data.map((v) => {
        concatList.push({
          text: v.dmmc,
          value: v.dm
        })
      })
      this.jslxColumns=concatList
    },
    async getTeaWeek() {
      const res = await Api.getTeachingWeek();
      let concatList = [];
      res.data.forEach((item, index) => {
        concatList[index] = {
          text: item.week,
          value: index + 1,
          isCheck:false,
        };
      });
      this.zcColumns = concatList
    },
    async bigJcFuct(){
      const res = await Api.bigJcNode();
      let concatList = [];
      res.data.forEach((item, index) => {
        concatList[index] = {
          text: item.JC,
          value: item.JC,
          isCheck:false,
        };
      });
      this.jcColumns = concatList
    },
    zcxzFuct(item,index){
      if(item.isCheck){
        this.zcColumns[index].isCheck = false
      }else{
        this.zcColumns[index].isCheck = true
      }
    },
    xqxzFuct(item,index){
      this.weekColumns.forEach((i,t)=>{
        i.isCheck = false
        if(!item.isCheck && index === t){
          i.isCheck = true
        }
      })
    },
    jcxzFuct(item,index){
      if(item.isCheck){
        this.jcColumns[index].isCheck = false
      }else{
        this.jcColumns[index].isCheck = true
      }
    },
    szxqConfirm(val){
      this.szxqId = val.value
      this.szxqName = val.text
      this.szxqShow = false
      this.getBuild(val.value)
      this.szlyId = ''
      this.szlyName = ''
    },
    szlyConfirm(val){
      this.szlyId = val.value
      this.szlyName = val.text
      this.szlyShow = false
    },
    jslxConfirm(val){
      this.jslxId = val.value
      this.jslxName = val.text
      this.jslxShow = false
    },
    sysjClose(){
      // this.zcColumns.forEach(i=>{
      //   this.$set(i,'isCheck',false)
      // })
      // this.weekColumns.forEach(i=>{
      //   this.$set(i,'isCheck',false)
      // })
      // this.jcColumns.forEach(i=>{
      //   this.$set(i,'isCheck',false)
      // })
      this.sysjShow = false
    },
    sysjConfirm(){
      var zcarr = []
      this.zcColumns.forEach(i=>{
        if(i.isCheck){
          zcarr.push(i)
        }
      })
      this.zcId = zcarr.map(i=>{return i.value}).join(',')
      var xqarr = []
      this.weekColumns.forEach(i=>{
        if(i.isCheck){
          xqarr.push(i)
        }
      })
      this.xqId = xqarr.map(i=>{return i.value}).join(',')
      var jcarr = []
      this.jcColumns.forEach(i=>{
        if(i.isCheck){
          jcarr.push(i)
        }
      })
      this.jcXzArr = []
      this.jcId = jcarr.map(i=>{
        var one = i.value.slice(0,2)
        var two = i.value.slice(2,4)
        var text = one+','+two
        if(i.value === '091011'){
          var three = i.value.slice(4,6)
          text = one+','+two+','+three
        }
        this.jcXzArr.push(text)
        return text
      }).join(',')
      var zctext = ''
      var xqtext = ''
      var jctext = ''
      if(zcarr.length>0){
        zctext = '周次:'+zcarr.map(i=>{return i.text}).join(',')
      }
      if(xqarr.length>0){
        xqtext = '星期:'+xqarr.map(i=>{return i.text}).join(',')
      }
      if(jcarr.length>0){
        jctext = '节次:'+jcarr.map(i=>{return i.text}).join(',')
      }
      this.sysjName = zctext + ' ' + xqtext + ' ' + jctext
      this.sysjShow = false
    },
    onSubmit(){
      if(!this.xqId){
        this.$toast('请选择星期')
        return
      }
      var zctext = ''
      if(this.zcId){
        zctext = '第'+this.zcId+'周'
      }
      this.$router.push({
        name:'njkx_table',
        params:{
          obj:{
            xqid:this.szxqId,
            jxlid:this.szlyId,
            jslx:this.jslxId,
            zc:this.zcId,
            week:this.xqId,
            jc:this.jcId,
            zctext:zctext,
          },
          jcXzArr:this.jcXzArr,
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.room{
.button-box{
  width: 100%;
  height: 70px;
  background: #fff;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.van-button {
  width: 90%;
  height: 50px;
  border: 1px solid #e5e5e5;
  border-radius: 3px !important;
}
.sysj-text{
  width: 100%;
  height: 60px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:0 16px;
  box-sizing: border-box;
}
.all-cont{
  width: 100%;
  padding:0 16px 16px;
  box-sizing: border-box;
}
.van-check{
  display: flex;
  flex-wrap: wrap;
  margin-top:10px;
  .van-li{
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    color:#7469F8;
    border:1px solid #7469F8;
    border-radius: 4px;
    margin:0 10px 10px 0;
  }
  .van-text{
    display: inline-block;
    height: 30px;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    color:#7469F8;
    border:1px solid #7469F8;
    border-radius: 4px;
    margin:0 10px 10px 0;
    padding:0 4px;
    box-sizing: border-box;
  }
  .van-on{
    background: #7469F8;
    color:#fff;
  }
}
}
</style>




// WEBPACK FOOTER //
// src/components/newPages/student/njkxRooms/index.vue